import { Node } from './api/APITypes';
import { SortOrderType } from './state/ViewTypes';

export default function sortNodes(nodes: Node[], sortOrder: SortOrderType) {
  switch (sortOrder) {
    case 'default':
      return nodes;
    case 'date':
      return [...nodes].sort(
        (a, b) =>
          new Date(b.specific_properties.judgementdate!).getTime() -
          new Date(a.specific_properties.judgementdate!).getTime(),
      );
    case 'relevance':
      return [...nodes].sort(
        (a, b) => a.specific_properties.importance! - b.specific_properties.importance!,
      );
  }
}
